import { FieldType } from 'constants/formGenerator';
import { formatCalendarDatePendingChange } from 'utils/pendingChanges';

import { tableCellDateTypes, TableCellId } from '../DocumentExpirationDates.constants';

export const fieldsPendingChangeNormalizers = [
  ...tableCellDateTypes.map(fieldName => ({
    fieldName,
    normalize: ({ pendingChange }) => formatCalendarDatePendingChange(pendingChange),
  })),
];

export const formConfig = {
  [TableCellId.TITLE]: { fieldType: FieldType.TEXT },
  [TableCellId.START_DATE]: { fieldType: FieldType.DATE },
  [TableCellId.EXPIRES_IN_DAYS]: { fieldType: FieldType.INTEGER },
  [TableCellId.EXPIRATION_DATE]: { fieldType: FieldType.DATE },
};

export const formFields = Object.keys(formConfig);
